import { register } from 'register-service-worker'

// if (process.env.NODE_ENV === 'production') {
  // register('https://garden.uniti.pl/service-worker.js', {
  register('/service-worker-dev.js', {
    message(data) {
      console.log('message');
      if (data && data.type === 'SKIP_WAITING') {
        self.skipWaiting()
      }
    },
    ready () {
      const version = `version-${process.env.VUE_APP_VERSION}`;
      console.log('ready');
    },
    registered (registration) {
      console.log('register');
      /*
      setInterval(() => {
        registration.update();
      }, 1000 * 60);
      */
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({
          type: 'MQTT_SUBSCRIBE',
          topic: 'notice'
        });
      } else {
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          navigator.serviceWorker.controller.postMessage({
            type: 'MQTT_SUBSCRIBE',
            topic: 'notice'
          });
        });
      }
    },
    cached () {},
    updatefound () {},
    updated (registration) {
      // document.dispatchEvent(
          // new CustomEvent('swUpdated', { detail: registration })
      // );
    },
    offline () {},
    error (error) {}
  })
// }
